import api from "./services/mkm.api.js"

const resource = "/error"

export default{
    post(message) {
        return api.post(`${resource}`, message);
    },
}
